import { render, staticRenderFns } from "./ViewDetailExercises.vue?vue&type=template&id=27c83566&scoped=true&"
import script from "./ViewDetailExercises.vue?vue&type=script&lang=js&"
export * from "./ViewDetailExercises.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailExercises.vue?vue&type=style&index=0&id=27c83566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c83566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow,VSpacer})
